import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { NotificationStatus } from '../../models/Notification';

@Component({
    selector: 'app-notification-status',
    template: `
<span class="badge"
        [class.text-bg-light]="value == 'Draft'"
        [class.text-bg-secondary]="value == 'Pending'"
        [class.text-bg-success]="value == 'Finished'">
    {{'notification_status' + value | translate}}
</span>
`
})
export class NotificationStatusComponent {
    @Input() value: NotificationStatus;
}
